import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DatastoreEquipmentGroupModule } from '@freelancer/datastore/collections';
import { TrackingModule } from '@freelancer/tracking';
import { UiModule } from '@freelancer/ui';
import { ItemSelectorModule } from 'app/item-selector/item-selector.module';
import { VehicleTypesFormComponent } from './vehicle-types/vehicle-types-form.component';

@NgModule({
  imports: [
    CommonModule,
    DatastoreEquipmentGroupModule,
    TrackingModule,
    UiModule,
    ItemSelectorModule,
  ],
  declarations: [VehicleTypesFormComponent],
  exports: [VehicleTypesFormComponent],
})
export class VehicleTypesModule {}
